export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc528b8668133cfa0cbd62ae060695cf746168f21&name=fetchTypeahead!'